import { render, staticRenderFns } from "./pageTab.vue?vue&type=template&id=7e683d0a&"
import script from "./pageTab.vue?vue&type=script&lang=js&"
export * from "./pageTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports